import { ChangeDetectionStrategy, Component } from '@angular/core';

interface Integration {
  alt: string;
  src: string;
}

@Component({
  selector: 'app-integrations-section',
  imports: [],
  templateUrl: './integrations-section.component.html',
  styleUrl: './integrations-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IntegrationsSectionComponent {
  protected readonly integrations: Integration[] = [
    {
      alt: 'Android',
      src: 'assets/images/integrations/android.svg',
    },
    {
      alt: 'App Store Connect',
      src: 'assets/images/integrations/app-store-connect.svg',
    },
    {
      alt: 'Apple',
      src: 'assets/images/integrations/apple.svg',
    },
    {
      alt: 'Azure DevOps',
      src: 'assets/images/integrations/azure-devops.svg',
    },
    {
      alt: 'Bitbucket',
      src: 'assets/images/integrations/bitbucket.svg',
    },
    {
      alt: 'Discord',
      src: 'assets/images/integrations/discord.svg',
    },
    {
      alt: 'Email',
      src: 'assets/images/integrations/email.svg',
    },
    {
      alt: 'Firebase',
      src: 'assets/images/integrations/firebase.svg',
    },
    {
      alt: 'GitHub',
      src: 'assets/images/integrations/github.svg',
    },
    {
      alt: 'GitLab',
      src: 'assets/images/integrations/gitlab.svg',
    },
    {
      alt: 'Ionic',
      src: 'assets/images/integrations/ionic.svg',
    },
    {
      alt: 'Node.js',
      src: 'assets/images/integrations/node.svg',
    },
    {
      alt: 'Play Store',
      src: 'assets/images/integrations/play-store.svg',
    },
    {
      alt: 'Slack',
      src: 'assets/images/integrations/slack.svg',
    },
    {
      alt: 'Trapeze',
      src: 'assets/images/integrations/trapeze.png',
    },
    {
      alt: 'Xcode',
      src: 'assets/images/integrations/Xcode.svg',
    },
  ];

  protected readonly visibleIntegrations = this.integrations.slice(0, 15);
}
